import React, { useState, useEffect } from "react";
import { StreamChat } from "stream-chat";
import { Chat } from "stream-chat-react";
import Cookies from "universal-cookie";

import { ChannelListContainer, ChannelContainer, Auth } from "./components";

import "stream-chat-react/dist/css/index.css";
import "./App.css";

const cookies = new Cookies();
const apiKey = "ektw4vev79cb";
const authToken = cookies.get("token");
const client = StreamChat.getInstance(apiKey);

if (authToken) {
  client.connectUser(
    {
      id: cookies.get("userId"),
      name: cookies.get("username"),
      fullName: cookies.get("fullName"),
      image: cookies.get("avatarURL"),
      hashedPassword: cookies.get("hashedPassword"),
      phoneNumber: cookies.get("phoneNumber"),
    },
    authToken
  );
}

const App = () => {
  const [createType, setCreateType] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);

  // Handle Notifications permission
  useEffect(() => {
    if (Notification.permission === "granted") {
      setNotificationsEnabled(true);
    }
  }, []);

  const enableNotifications = () => {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        setNotificationsEnabled(true);
      }
    });
  };

  // Ensure client is connected before subscribing to messages
  useEffect(() => {
    if (!authToken) return; // Don't run if user is not authenticated

    const handleNewMessage = (event) => {
      if (notificationsEnabled && event.type === "message.new") {
        new Notification("New Message", {
          body: `${event.user.name}: ${event.message.text}`,
        });
      }
    };

    client.on("message.new", handleNewMessage);

    return () => client.off("message.new", handleNewMessage);
  }, [notificationsEnabled, authToken]); // Add authToken to dependency array

  if (!authToken) {
    return <Auth />;
  }

  return (
    <div className="app__wrapper">
      {!notificationsEnabled && (
        <div className="notification-banner">
          Pager needs your permission to{" "}
          <span onClick={enableNotifications} className="enable-link">
            enable desktop notifications
          </span>
        </div>
      )}

      <Chat client={client} theme="team light">      
        <ChannelListContainer
          isCreating={isCreating}
          setIsCreating={setIsCreating}
          setCreateType={setCreateType}
          setIsEditing={setIsEditing}
        />
        <ChannelContainer
          isCreating={isCreating}
          setIsCreating={setIsCreating}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          createType={createType}
        />
      </Chat>
    </div>
  );
};

export default App;
